import { RecommendationsProductProps } from './types'
import { StandardProductCard } from '@/features/product/components/StandardProductCard'
import { createLiquidExtendedProductHit } from '@/features/product/utils/createExtendedProductHit'

export const RecommendedProduct = ({
  product,
}: RecommendationsProductProps) => (
  <StandardProductCard
    product={createLiquidExtendedProductHit(product)}
    useQuickAdd
  />
)
